module.exports = __webpack_public_path__ + "static/media/Herica_12.76785662.jpg";